import { useMutation } from '@tanstack/react-query'
import { checkoutSubscriptionService, type CheckoutPayload } from '@/services/subscriptions'

export const useCheckoutSubscription = (agendaId: string) =>
  useMutation({
    mutationFn: (payload: CheckoutPayload) => checkoutSubscriptionService(agendaId, payload),
  })
